// カートのカウントを更新する
window.cartCountUpdate = function () {
  /* global hUrl */

  window.getAjax({
    url: hUrl + 'cart/', //取得先のURL
    param: '', // パラメータ hoge=111&fuga=222
    method: 'get', // get/post
    isCache: true, // 取得先のキャッシュ有効/無効
    responseType: 'document', // 取得タイプ document text json
    callback: function (response) {
      const countItem = response.querySelector('.js-cartCount')
      const countValue = countItem.innerText

      const countList = document.getElementsByClassName('js-cartCount')
      for (const element of countList) {
        element.innerText = countValue
      }
    }, // コールバック関数
  })
}
